import { PackageCardData } from "../../components/rn-business-components/package-card/package-card-data";

export class PackageUpdateEventData {
  constructor(
    public userId: number,
    public packageCardData: PackageCardData,
  ) {}
}
